import { useDispatch } from 'react-redux';
import { convertCurrency } from 'utils/general';
import { deleteQuote, deleteInvoice } from 'containers/Leads/Lead/actions';
import QuoteIcon from 'assets/images/documents/Quote.svg';
import InvoiceIcon from 'assets/images/documents/Invoice.svg';
import dayjs from 'dayjs';
import StatusIndicator from './StatusIndicator';
import DocumentOptions from './DocumentOptions';

const TYPE_ICONS = {
  quote: QuoteIcon,
  invoice: InvoiceIcon,
};

const QuoteInvoiceListItem = ({
  id,
  type,
  name,
  identifier,
  currency,
  total,
  paid,
  balance,
  status,
  onClick,
  orgId,
  leadId,
  showOptions = true,
  showDelete = true,
  confirmMessage,
  confirmText,
  viewToken,
  requireConfirmation,
  isPublished,
  currentlyPublishedVersion,
  version,
  expirationDate: expirationDateString,
}) => {
  const dispatch = useDispatch();
  const icon = TYPE_ICONS[type];
  const expirationDate = expirationDateString ? dayjs(expirationDateString) : null;

  let finalStatus = status;
  if (
    type === 'invoice' && isPublished && currentlyPublishedVersion
    && version && currentlyPublishedVersion !== version
  ) {
    finalStatus = 'unpublished_changes';
  }
  if (
    (status === 'sent' || status === 'draft') &&
    expirationDate && dayjs().isAfter(expirationDate)
  ) {
    finalStatus = 'expired';
  }

  const amounts = [];
  if (total) {
    amounts.push(`Total: ${convertCurrency(total, currency)}`);

    if (type === 'invoice') {
      amounts.push(`Paid: ${convertCurrency(paid || 0, currency)}`);
    } else if (paid) {
      amounts.push(`Paid: ${convertCurrency(paid, currency)}`);
    }
    if (type === 'invoice') {
      amounts.push(`Balance Due: ${convertCurrency(balance || 0, currency)}`);
    } else if (balance) {
      amounts.push(`Balance Due: ${convertCurrency(balance, currency)}`);
    }
  }

  const openPreview = () => {
    window.open(`/app/${type}-preview/${id}`, '_blank');
  };

  const onView = (token) => {
    window.open(`/${type}/view/${token}`);
  };

  const handleDelete = () => {
    if (type === 'quote') {
      dispatch(deleteQuote(orgId, id, leadId));
    }

    if (type === 'invoice') {
      dispatch(deleteInvoice(orgId, id, leadId));
    }
  };

  return (
    <div className="lead-document"
      onClick={() => onClick(id)}
    >
      <div className="lead-document__icon">
        <img
          src={icon}
          alt={name}
        />
      </div>
      <div className="lead-document__content">
        <div className="lead-document__name">{name}</div>
        <div className="lead-document__kind">{type} #{identifier}</div>
        {amounts.length > 0 ? (
          <div className="lead-document__amounts">
            {amounts.join(' | ')}
          </div>
        ) : null}
        {showOptions && (
          <div
            className="lead-document__options"
            onClick={(e) => e.stopPropagation()}
          >
            <DocumentOptions
              onPreview={openPreview}
              onView={onView}
              onDelete={handleDelete}
              showDelete = {showDelete}
              confirmMessage = {confirmMessage}
              confirmText = {confirmText}
              requireConfirmation = {requireConfirmation}
              viewToken={viewToken}
              documentKind={type}
            />
          </div>
        )}
      </div>
      <StatusIndicator status={finalStatus} />
    </div>
  );
};

export default QuoteInvoiceListItem;
